import styled from "@emotion/styled";
import {useNavigate} from "react-router-dom";
import {useSetRecoilState} from "recoil";
import {providerState} from "../../../atom/simpleCert";
import {routes} from "../../../constants/routes";

const Container = styled.button`
    padding: 1px;
    background-color: unset;
    border: none;
    display: flex;
    flex-direction: column;
    cursor: pointer;
    width: 100%;
    height: 100%;
`;

interface ImageProps {
    url: string;
}

const ImageBox = styled.div`
    padding: 20%;
    width: 100%;
    height: 100%;
    border-radius: 10px;
    border: 1px solid #f4f4f4;
`;

const Image = styled.div<ImageProps>`
    width: 100%;
    height: 100%;
    aspect-ratio: 1;
    background-color: #fff;
    background-image: url(${({url}) => url});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    border: none;
    border-radius: 4px;
`;

const Text = styled.div`
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    width: 100%;
    text-align: center;
    margin-top: 6px;
    color: #646464;
`;

interface Props {
    url: string;
    text: string;
    id: string;
}

export default function Method({url, text, id}: Props) {
    const setProvider = useSetRecoilState(providerState);
    const navigate = useNavigate();

    const select = (id: string) => {
        setProvider(id);
        navigate(routes.simpleCert.request);
    };

    return (
        <Container title={text} onClick={() => select(id)}>
            <ImageBox> <Image url={url}/> </ImageBox>
            <Text>{text}</Text>
        </Container>
    );
}
